module.exports = __webpack_public_path__ + "img/ZWF_Michael_Aline.b24d7523.jpg";